import DropDownMenu_TextOnlyMenuButtonBgFixSkinComponent from '../components/DropDownMenu/viewer/skinComps/TextOnlyMenuButtonBgFixSkin/TextOnlyMenuButtonBgFixSkin.skin';
import DropDownMenu_TextOnlyMenuButtonBgFixSkinController from '../components/DropDownMenu/viewer/DropDownMenu.controller';


const DropDownMenu_TextOnlyMenuButtonBgFixSkin = {
  component: DropDownMenu_TextOnlyMenuButtonBgFixSkinComponent,
  controller: DropDownMenu_TextOnlyMenuButtonBgFixSkinController
};


export const components = {
  ['DropDownMenu_TextOnlyMenuButtonBgFixSkin']: DropDownMenu_TextOnlyMenuButtonBgFixSkin
};

